import React from 'react'
import { Button, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import { Controller } from 'react-hook-form';
import { useStateValue } from '../../context/store';
import { styleSearch } from './styles';

const JobApprovalSearch = ({charge, regionals, handleSubmit, register, errors, clearForm, control}) => {
    const classes = styleSearch()
    const [{}, dispatch] = useStateValue();

    const onSubmit = (data) => {
        if(
            data.firstName !== null ||
            data.surname !== null ||
            data.chargeId !== null ||
            data.regionalId !== null
        ){
            dispatch({
                type: "SET_PERMISSIONS_FILTER",
                filter: data,
                isFilter: true,
            })
        }
    }

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={6} md={2} lg={2} >
                        <FormControl
                            fullWidth
                            size='small'
                            variant='outlined'
                        >
                            <TextField
                                fullWidth
                                type="text"
                                variant='outlined'
                                inputRef={register}
                                label="Primer nombre*"
                                name="firstName"
                                defaultValue=""
                                size='small'
                                InputLabelProps={{shrink: true}}
                                error={!!errors.hasOwnProperty("firstName") && errors["firstName"].message }
                            />
                            <FormHelperText style={{color: "#f44336", paddingLeft: 14}} >
                                {errors.hasOwnProperty('firstName') && errors['firstName'].message}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} md={2} lg={2} >
                        <FormControl
                            fullWidth
                            size='small'
                            variant='outlined'
                        >
                            <TextField
                                fullWidth
                                type="text"
                                variant='outlined'
                                inputRef={register}
                                label="Primer apellido*"
                                name="surname"
                                defaultValue=""
                                size='small'
                                InputLabelProps={{shrink: true}}
                                error={!!errors.hasOwnProperty("surname") && errors["surname"].message }
                            />
                            <FormHelperText style={{color: "#f44336", paddingLeft: 14}} >
                                {errors.hasOwnProperty('surname') && errors['surname'].message}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} md={2} lg={2} >
                        <FormControl
                            variant="outlined"
                            fullWidth
                            size='small'
                            error={!!errors.hasOwnProperty("chargeId") && errors["chargeId"].message }
                        >
                            <InputLabel htmlFor="outlined-select-chargeId" shrink={true}>
                                Cargo*
                            </InputLabel>
                            <Controller
                                fullWidth
                                name='chargeId'
                                size="small"
                                control={control}
                                defaultValue=""
                                inputRef={register}
                                label="Tipo de contrato *"
                                notched={true}
                                inputProps={{
                                    name: "chargeId",
                                    id: "outlined-select-chargeId",
                                }}
                                as={
                                    <Select>
                                        {
                                          charge?.map(res => (
                                            <MenuItem
                                                className={classes.menuItem}
                                                key={res?.id}
                                                value={res?.id}
                                            >
                                                {res.denomination}
                                            </MenuItem>
                                            ))
                                        }
                                    </Select>
                                }
                            />
                            <FormHelperText>
                                {errors.hasOwnProperty("chargeId") && errors["chargeId"].message}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} md={2} lg={2} >
                        <FormControl
                            variant="outlined"
                            fullWidth
                            size='small'
                            error={!!errors.hasOwnProperty("regionalId") && errors["regionalId"].message }
                        >
                            <InputLabel htmlFor="outlined-select-regionalId" shrink={true}>
                                Regional*
                            </InputLabel>
                            <Controller
                                fullWidth
                                control={control}
                                name='regionalId'
                                inputRef={register}
                                size="small"
                                label="regionalId *"
                                defaultValue=""
                                notched={true}
                                inputProps={{
                                    name: "regionalId",
                                    id: "outlined-select-regionalId",
                                }}
                                as={
                                    <Select>
                                       {
                                            regionals?.map(resp => (
                                                <MenuItem
                                                    className={classes.menuItem}
                                                    key={resp?.id}
                                                    value={resp?.id}
                                                >
                                                    {resp.name}
                                                </MenuItem>
                                            ))
                                       }
                                    </Select>
                                }
                            />
                            <FormHelperText>
                                {errors.hasOwnProperty("regionalId") && errors["regionalId"].message}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} md={3} lg={3} >
                        <Button
                            type="submit"
                            variant="contained"
                            className={classes.buttonSearch}
                        >
                            Buscar
                        </Button>
                        <Button
                            variant="contained"
                            className={classes.buttonSearch}
                            onClick={clearForm}
                        >
                            Limpiar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    )
}

export default JobApprovalSearch;